import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { TagsDashboardQueryKeys } from "modules/TagsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { Tag } from "models";

export const useTagsListeners = () =>
  useMemo(() => {
    const tagsListeners: WebSocketMessageListener<Tag>[] = [
      {
        model: "Tag",
        action: "upsert",
        callback: ({ data: tag }) => {
          const tags = typedQueryClient.getQueryData(TagsDashboardQueryKeys.tags);

          const tagIdx = tags?.findIndex(t => t.id === tag.id) ?? -1;
          const updatedTags = [...(tags ?? [])];

          typedQueryClient.setQueryData(
            TagsDashboardQueryKeys.tags,
            tagIdx === -1 ? [tag, ...updatedTags] : updatedTags.with(tagIdx, { ...updatedTags[tagIdx], ...tag })
          );
        }
      },
      {
        model: "Tag",
        action: "delete",
        callback: ({ data: tag }) => {
          const tags = typedQueryClient.getQueryData(TagsDashboardQueryKeys.tags);
          if (!tags?.length) return;

          const tagIdx = tags.findIndex(t => t.id === tag.id);
          if (tagIdx === -1) return;

          typedQueryClient.setQueryData(TagsDashboardQueryKeys.tags, tags.toSpliced(tagIdx, 1));
        }
      }
    ];

    return tagsListeners;
  }, []);
